export interface KanbanViewHeaderI {
    title: string;
    total: string;
    name: string;
    position: number;
    duration: string;
    dropOff: string;
    dropOffHour: string;
}

export interface KanbanViewCardI {
    select: boolean;
    id: string;
    orderNo: string;
    orderIdentity: string;
    orderDate: string;
    accountName: string;
    salesPerson: string;
    contactName: string;
    kanbanStatus: string;
    inHandDateBy: string;
}

export interface KanbanViewListI {
    id: string;                     
    header: KanbanViewHeaderI,
    cards: KanbanViewCardI[]; 
}
